// extracted by mini-css-extract-plugin
export default {"container":"DeactivatePopup_container__fSgfd","actions":"DeactivatePopup_actions__Y1rtB"};